@if (visible) {
<div class="drawer">
  <div class="drawer__backdrop" (click)="close(); closeAttachMenu()"></div>
  <div class="drawer__panel">
    <div class="drawer__header">
      <div class="title">{{ "Linked investment(s) to the equipment" | translate }}</div>
      <div class="icons-container">
        <span class="close-btn" (click)="close()">
          <i class="fa-light fa-x"></i>
        </span>
      </div>
    </div>

    <div class="drawer__content">
      <nb-card [nbSpinner]="loading">
        <nb-card-body>
          <nb-list>
            @for (item of investments; track item.id) {
              <nb-list-item class="investment-item">
                <div class="investment-content" (click)="openInvestment(item.id)">
                  <div class="investment-name">{{ item.label }}</div>
                  <div class="investment-details">
                    <span class="investment-status">{{ "Status" | translate }}: {{ item.status }}</span>
                    <span class="investment-budget">{{ item.budgetFormatted }} {{ "in" | translate }} {{ item.year }} ({{ item.estimateText }})</span>
                    @if (item.impactIndicators) {
                      <span class="investment-impact">{{ "Impact" | translate }}: {{ item.impactIndicators }}</span>
                    }
                  </div>
                </div>
                <div class="investment-icon" (click)="unlinkInvestment(item)">
                  <i class="fa-light fa-link-slash"></i>
                </div>
              </nb-list-item>
            }
          </nb-list>

          <div *ngIf="globalInvestments.length > 0">
            <div class="container pt-2 lead">
             {{ "Global investments" | translate }}
            </div>
            <nb-list >
              @for (item of globalInvestments; track item.id) {
                <nb-list-item class="investment-item">
                  <div class="investment-content" (click)="openInvestment(item.id)">
                    <div class="investment-name">{{ item.label }}</div>
                    <div class="investment-details">
                      <span class="investment-status">{{ "Status" | translate }}: {{ item.status }}</span>
                    </div>
                  </div>
                  <div class="investment-icon" (click)="unlinkGlobalInvestment(item)">
                    <i class="fa-light fa-link-slash"></i>
                  </div>
                </nb-list-item>
              }
              </nb-list>
          </div>
        </nb-card-body>
      </nb-card>

      @if (canAttachInvestment()) {
        <div class="attach-menu-container" appOutsideClick (outsideClick)="closeAttachMenu()">
          <button class="paperclip-icon" (click)="toggleAttachMenu()" [attr.aria-label]="'Attach an investment' | translate">
            <i class="fa-light fa-link"></i>
          </button>
          @if (showAttachMenu) {
            <div class="attach-menu-popup">
              <div class="attach-menu-item" (click)="openAttachExistingInvestment()">
                {{ "Attach to the equipment an existing investment" | translate }}
              </div>
              <div class="attach-menu-divider"></div>
              <div class="attach-menu-item" (click)="openAttachNewInvestment()">
                {{ "Attach to the equipment a new investment" | translate }}
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
}
